import { ajaxSend } from 'api/api';
const BULK_ENDPOINT_PARAMS = {
    addInternalNote: { path: '/v1/conversations/bulk/wrapup', method: 'POST' },
    claim: { path: '/v1/conversations/bulk/claim', method: 'POST' },
    close: { path: '/v1/conversations/bulk/close', method: 'POST' },
    sendReply: { path: '/v1/conversations/bulk/reply', method: 'POST' },
    addTag: { path: '/v1/conversations/bulk/tag', method: 'POST' },
    removeTag: { path: '/v1/conversations/bulk/tag', method: 'DELETE' },
    transferToQueue: {
        path: '/v1/conversations/bulk/transfer/queue',
        method: 'POST',
    },
    cancelCSAT: {
        path: '/v1/conversations/bulk/cancel_csat',
        method: 'POST',
    },
};
export function bulkActionApi(genPayload) {
    const { bulkType, data } = genPayload;
    return ajaxSend(Object.assign(Object.assign({}, BULK_ENDPOINT_PARAMS[bulkType]), { data }));
}
export const BulkActionTypeMap = {
    Tag: 'addTag',
    Untag: 'removeTag',
    Close: 'close',
    Transer: 'transferToQueue',
    Wrapup: 'addInternalNote',
    Claim: 'claim',
    'Send reply': 'sendReply',
    'Cancel CSAT': 'cancelCSAT',
};
export function getBulkActions() {
    return ajaxSend({
        path: '/v1/conversations/bulk',
    });
}
export function getBulkActionById(bulkId) {
    return ajaxSend({
        path: `/v1/conversations/bulk/${bulkId}`,
    });
}
export function getBulkActionFailedActionsById(bulkId) {
    return ajaxSend({
        path: `/v1/conversations/bulk/${bulkId}/failed_actions`,
    });
}
